import React from 'react';
import { Button, notification, Popconfirm } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { SwapOutlined } from '@ant-design/icons';
import { updateServiceStatus } from 'services/pricing';

export type ServiceStatusButtonProps = ButtonProps & {
  servcode: string;
  status: string;
  refetch: () => void;
};

const ServiceStatusButton: React.FC<ServiceStatusButtonProps> = ({
  size = 'small',
  servcode,
  status,
  refetch,

  ...props
}) => {
  let newStatus = '',
    statuslabel = '';
  switch (status) {
    case 'INIT':
      newStatus = 'ACTIVE';
      statuslabel = 'Activate';
      break;
    case 'ACTIVE':
      newStatus = 'DISABLED';
      statuslabel = 'Disable';
      break;
    case 'DISABLED':
      newStatus = 'END';
      statuslabel = 'Terminate';
      break;
    case 'END':
      newStatus = 'ACTIVE';
      statuslabel = 'Activate';
      break;
  }
  return (
    <Popconfirm
      title="Sure to change the status?"
      onConfirm={() => {
        updateServiceStatus({
          servcode,
          status: newStatus,
        }).then((res) => {
          notification.success({ message: res.message });
          refetch();
        });
      }}
    >
      <Button
        icon={<SwapOutlined />}
        onClick={() => {}}
        {...props}
        style={{
          width: 100,
          height: 41,
          marginBottom: 5,
          marginLeft: 5,
          marginRight: 5,
        }}
      >
        {statuslabel}
      </Button>
    </Popconfirm>
  );
};

export default ServiceStatusButton;
